<template>
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>商品カテゴリ追加</v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="addItemCategoryName"
              label="商品カテゴリ名"
              :counter="15"
              v-validate="'required|max:15|min:2'"
              data-vv-name="itemCategoryName"
              :error-messages="errors.collect('itemCategoryName')"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 align-self-center>
            <v-btn block color="success" dark @click="addItem()">
              <v-icon dark>add</v-icon>追加
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <br />

    <v-card>
      <v-container>
        <v-card-title>商品カテゴリ一覧</v-card-title>
        <v-data-table
          :headers="headers"
          :items="itemCategories"
          class="elevation-1"
          :sort-by="['itemCategoryId']"
          :sort-desc="[false]"
          :custom-sort="customSort"
          hide-actions
        >
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <tr
              v-bind:class="{
                'disabled-class-name': props.item.status === '0'
              }"
            >
              <td class="text-xs-left">{{ props.item.itemCategoryId }}</td>
              <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
              <td class="text-xs-left">
                <a
                  @click="editItem(props.item)"
                  v-if="props.item.status === '1'"
                  >有効</a
                >

                <a v-else>
                  <a
                    @click="editItem(props.item)"
                    v-if="props.item.status === '0'"
                    >無効</a
                  >
                </a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-layout row wrap style="margin-top: 30px;">
      <v-flex xs12 sm12>
        <v-btn
          block
          color="#4C728A"
          dark
          :to="{ name: 'admin/new-admin-menu' }"
        >
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-container>
          <v-card-title>
            <span class="headline">ステータス設定</span>
          </v-card-title>
          <v-layout row wrap align-center>
            <v-flex>
              <v-select
                v-model="editingItemCategory"
                :items="statuses"
                item-text="statusName"
                item-value="statusCode"
                label="ステータス"
                return-object
              ></v-select>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close()">
              <v-icon dark>arrow_back</v-icon>{{ $t('back-btn') }}
            </v-btn>
            <v-btn color="blue darken-1" flat @click="save()">
              <v-icon dark>save</v-icon>変更
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  data() {
    return {
      addItemCategoryName: '',
      dialog: false,
      editingItemCategoryId: '',
      editingItemCategory: {
        statusName: '',
        statusCode: ''
      },
      statuses: [
        {
          statusName: '有効',
          statusCode: '1'
        },
        {
          statusName: '無効',
          statusCode: '0'
        }
      ],
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'itemCategoryId'
        },
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          sortable: false
        },
        {
          text: 'ステータス',
          align: 'left',
          value: 'status',
          sortable: false
        }
      ],
      itemCategories: []
    }
  },
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this
    ServerApiCallService.itemCategories()
      .then(response => {
        console.log('created')
        thisObj.itemCategories = response.data.itemCategories
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    customSort(items, index, isDesc) {
      console.log('custom sort. itemCategoryId ')
      items.sort((a, b) => {
        if (!isDesc) {
          if (a.itemCategoryId < b.itemCategoryId) {
            return -1
          } else if (a.itemCategoryId > b.itemCategoryId) {
            return 1
          }
        } else {
          if (a.itemCategoryId < b.itemCategoryId) {
            return 1
          } else if (a.itemCategoryId > b.itemCategoryId) {
            return -1
          }
        }
        return 0
      })
      return items
    },
    addItem() {
      console.log('add Item')
      let thisObj = this
      let request = {
        itemCategoryName: this.addItemCategoryName
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
      
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
        ServerApiCallService.itemCategoriesPost(request, sendContext)
          .then(response => {
            thisObj.itemCategory = response.data.itemCategory
            thisObj.itemCategories.push({
              itemCategoryId: thisObj.itemCategory.itemCategoryId,
              itemCategoryName: thisObj.itemCategory.itemCategoryName,
              status: thisObj.itemCategory.status
            })
            thisObj.addItemCategoryName = ''
            this.$validator.reset()
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    editItem(item) {
      let thisObj = this
      console.log('open edit item dialog')
      thisObj.itemCategories.forEach(function(row) {
        if (row.itemCategoryId === item.itemCategoryId) {
          thisObj.statuses.forEach(function(status) {
            if (status.statusCode === item.status) {
              ;(thisObj.editingItemCategoryId = item.itemCategoryId),
                (thisObj.editingItemCategory = {
                  statusName: status.statusName,
                  statusCode: status.statusCode
                })
            }
          })
        }
      })
      this.dialog = true
    },
    save() {
      console.log('save')
      let thisObj = this
      let request = {
        itemCategoryId: this.editingItemCategoryId,
        status: this.editingItemCategory.statusCode
      }

      ServerApiCallService.itemCategoriesPut(request)
        .then(response => {
          if (response.data.result == '0') {
            thisObj.itemCategories.forEach(function(row) {
              console.log('success updating status')
              if (row.itemCategoryId === thisObj.editingItemCategoryId) {
                row.status = thisObj.editingItemCategory.statusCode
              }
            })
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      // Object.assign(this.itemCategories[this.editedIndex], this.editedItem)
      this.close()
    },
    close() {
      this.dialog = false
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  }
}
</script>

<style>
.disabled-class-name {
  background-color: #b3b3b3;
}
</style>
